module.exports = __webpack_public_path__ + "slider-1.jpg?256cfe04b1b8682ba4442454907e7c7a";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/slider-1.jpg
// module id = 302
// module chunks = 0